import { render, staticRenderFns } from "./inventoryStockSalesBreakdownWidget.vue?vue&type=template&id=50772d1f&"
import script from "./inventoryStockSalesBreakdownWidget.vue?vue&type=script&lang=js&"
export * from "./inventoryStockSalesBreakdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports